import { render, staticRenderFns } from "./HelpfulLinkIndex.vue?vue&type=template&id=3f3f0d28"
import script from "./HelpfulLinkIndex.vue?vue&type=script&lang=ts"
export * from "./HelpfulLinkIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports